"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var TxModalComponent = /** @class */ (function () {
    function TxModalComponent() {
        this.txOnSubmit = new core_1.EventEmitter();
    }
    TxModalComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(TxModalComponent.prototype, "title", {
        get: function () {
            return this._title;
        },
        set: function (title) {
            this._title = title;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TxModalComponent.prototype, "message", {
        get: function () {
            return this._message;
        },
        set: function (message) {
            this._message = message;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TxModalComponent.prototype, "modalActions", {
        get: function () {
            return this._modalActions;
        },
        set: function (modalActions) {
            this._modalActions = modalActions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TxModalComponent.prototype, "model", {
        get: function () {
            return this._model;
        },
        set: function (model) {
            this._model = model;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TxModalComponent.prototype, "refuseButton", {
        get: function () {
            return this._refuseButton;
        },
        set: function (refuseButton) {
            this._refuseButton = refuseButton;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TxModalComponent.prototype, "submitButton", {
        get: function () {
            return this._submitButton;
        },
        set: function (submitButton) {
            this._submitButton = submitButton;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TxModalComponent.prototype, "modalClass", {
        get: function () {
            if (!this._modalClass) {
                this._modalClass = "default-modal";
            }
            return this._modalClass;
        },
        set: function (modalClass) {
            this._modalClass = modalClass;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TxModalComponent.prototype, "contentClass", {
        get: function () {
            if (!this._contentClass) {
                this._contentClass = "default-modal-content";
            }
            return this._contentClass;
        },
        set: function (contentClass) {
            this._contentClass = contentClass;
        },
        enumerable: true,
        configurable: true
    });
    TxModalComponent.prototype.close = function () {
        this.modalActions.emit({ action: 'modal', params: ['close'] });
    };
    TxModalComponent.prototype.submit = function () {
        this.txOnSubmit.emit(this._model);
    };
    TxModalComponent.ctorParameters = function () { return []; };
    return TxModalComponent;
}());
exports.TxModalComponent = TxModalComponent;
//# sourceMappingURL=tx-modal-component.js.map


// WEBPACK FOOTER //
// tx-modal-component.js